import { useFormContext } from "react-hook-form";
import dayjs from "dayjs";

const Index = () => {
  const { getValues } = useFormContext();
  const datumUlaska = getValues("datumUlaska");
  const prirodaObvezeIzvjescivanja = getValues("prirodaObvezeIzvjescivanja");

  return (
    <div>
      <h4>Izvjestitelj (Reporter)</h4>
      <div>
        <p>
          Datum ulaska u status operatera platforme koji izvješćuje
          (Commencement date of reporting operator):{" "}
          <strong> {dayjs(datumUlaska).format("DD/MM/YYYY")}</strong>
        </p>
      </div>
      {prirodaObvezeIzvjescivanja && (
        <div>
          <div>
            <strong>
              Priroda obveze izvješćivanja (Nature of reporting obligation):
            </strong>
          </div>
          <div>
            <p>
              <span>{prirodaObvezeIzvjescivanja}</span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Index;
